export function isRefObject(x) {
    if (!x || typeof x !== 'object') {
        return false;
    }
    return 'current' in x;
}
